//import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import DefaultFilters from 'design-comuni-plone-theme/components/ItaliaTheme/Blocks/EventSearch/DefaultFilters';
import { SelectFilter } from 'design-comuni-plone-theme/components/ItaliaTheme/Blocks/Common/SearchFilters';

import { messages } from 'parma-theme/messages';

/*
  ***
  componente da customizzare nel proprio sito per modificare/aggiungere tipologie di Filtri
  ***
 */
const FiltersConfig = (dispatchFilter) => {
  const intl = useIntl();
  const defaultFilters = DefaultFilters(dispatchFilter);

  defaultFilters.text_filter.widget.props.placeholder = intl.formatMessage(
    messages.parma_text_search_placeholder,
  );
  defaultFilters.date_filter.widget.props.value.startDate = null;
  defaultFilters.date_filter.widget.props.value.endDate = null;
  defaultFilters.date_filter.widget.props.defaultStart = null;
  defaultFilters.date_filter.widget.props.defaultEnd = null;

  return {
    ...defaultFilters,
    subject_filter: {
      label: intl.formatMessage(messages.subject_filter),
      type: 'subject_filter',
      widget: {
        component: SelectFilter,
        props: {
          value: null,
          options: {
            vocabulary: 'plone.app.vocabularies.Keywords',
            placeholder: intl.formatMessage(messages.subjects),
          },
        },
      },
      query: (value, query) => {
        if (value?.value) {
          query.push({
            i: 'Subject',
            o: 'plone.app.querystring.operation.selection.any',
            v: [value.value],
          });
        }
      },
    },
  };
};

export default FiltersConfig;
